import { useContext } from "react";
import { useLocStore } from "../../../localization";
import { LocContext } from "../../../localization/LocContext";
import { persistAndStopPropagation } from "../../../utils/util";
import {
  useEnableParameterOverrides,
  AdminContext,
} from "../../adminSettings/AdminContext";

export function useEnableParameterOverridesMenuItem() {
  const L = useLocStore(LocContext.PROFILE);
  const enableParameterOverrides = useEnableParameterOverrides();
  const adminContext = useContext(AdminContext);

  return {
    label: L.id("ce0e07d21a8c").loc("Aktiver parameter-overrides"),
    icon: enableParameterOverrides ? "pi pi-fw pi-check-circle" : "pi pi-fw pi-circle",
    className: "vpn-item",
    keepOpen: true,
    onClick: (evt) => {
      adminContext.setEnableParameterOverrides(!enableParameterOverrides);
      evt.preventDefault();
      persistAndStopPropagation(evt);
    },
  };
}
